<script setup lang="ts">
import { Drawer, DrawerContent } from '@/components/ui/drawer'
import ModalWrapper from '@/components/modals/ModalWrapper.vue'
import { useAppMode } from '@/composables/useAppMode'

defineProps<{
  open: boolean
  modal?: boolean
  drawer?: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const { mode } = useAppMode()
</script>

<template>
  <modal-wrapper v-if="modal && (mode === 'desktop' || !drawer)">
    <slot />
  </modal-wrapper>
  <div v-else-if="drawer && mode === 'mobile'">
    <drawer :open="open" @update:open="(value) => !value && $emit('close')" class="abc">
      <drawer-content>
        <slot />
      </drawer-content>
    </drawer>
  </div>
  <slot v-else />
</template>

<style lang="scss">
[vaul-drawer] {
  .panel--mobile {
    max-width: 100%;
    width: 100%;
    position: static !important;
  }
}
</style>
